import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-error',
    templateUrl: './error.component.html',
    styleUrls: ['./error.component.scss'],
    standalone: false
})
export class ErrorComponent implements OnInit {
  errorMessage: string = 'An error occurred. Please check the link and try again.';

  constructor(private router: Router) {}

  ngOnInit(): void {
    // Try to get the error message from router state
    const navigation = this.router.getCurrentNavigation();
    if (navigation?.extras?.state) {
      this.errorMessage = navigation.extras.state['message'] || this.errorMessage;
    }
  }
}
